export const METRIKA_COUNTER_ID = 110120936;
export const REGISTRATION_CONFIRMED_GOAL = 'registration_confirmed';

const REGISTRATION_DEDUP_KEY_PREFIX = 'speeddate_metrika_registration_confirmed_sent';
const GENDER_DEDUP_KEY_PREFIX = 'speeddate_metrika_registration_gender_sent';
const inMemoryDedupeKeys = new Set();

const GENDER_GOALS = {
  female: 'registration_confirmed_female',
  male: 'registration_confirmed_male',
  unknown: 'registration_confirmed_unknown',
};

const canUseLocalStorage = () =>
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const normalizeDedupeId = (value) => {
  if (value == null) {
    return '';
  }

  return String(value).trim().replace(/[^a-zA-Z0-9:._-]/g, '').slice(0, 128);
};

const hasDedupeKey = (key) => {
  if (inMemoryDedupeKeys.has(key)) {
    return true;
  }

  if (!canUseLocalStorage()) {
    return false;
  }

  try {
    return Boolean(window.localStorage.getItem(key));
  } catch (error) {
    console.warn('Metrika dedupe read skipped:', error);
    return false;
  }
};

const setDedupeKey = (key) => {
  inMemoryDedupeKeys.add(key);

  if (!canUseLocalStorage()) {
    return;
  }

  try {
    window.localStorage.setItem(key, new Date().toISOString());
  } catch (error) {
    console.warn('Metrika dedupe write skipped:', error);
  }
};

export const reachMetrikaGoal = (goalName) => {
  if (typeof window === 'undefined' || typeof window.ym !== 'function') {
    return false;
  }

  window.ym(METRIKA_COUNTER_ID, 'reachGoal', goalName);
  return true;
};

export const trackRegistrationConfirmedOnce = ({ registrationConversionId, userId } = {}) => {
  const dedupeId = normalizeDedupeId(registrationConversionId || userId);

  if (!dedupeId) {
    return reachMetrikaGoal(REGISTRATION_CONFIRMED_GOAL);
  }

  const dedupeKey = `${REGISTRATION_DEDUP_KEY_PREFIX}:${dedupeId}`;
  if (hasDedupeKey(dedupeKey)) {
    return false;
  }

  const sent = reachMetrikaGoal(REGISTRATION_CONFIRMED_GOAL);
  if (sent) {
    setDedupeKey(dedupeKey);
  }

  return sent;
};

export const trackRegistrationGenderOnce = ({ gender, userId } = {}) => {
  const dedupeId = normalizeDedupeId(userId);
  if (!dedupeId) {
    return false;
  }

  const normalizedGender = gender === 'female' || gender === 'male' ? gender : 'unknown';
  const goalName = GENDER_GOALS[normalizedGender];
  const dedupeKey = `${GENDER_DEDUP_KEY_PREFIX}:${dedupeId}:${goalName}`;

  if (hasDedupeKey(dedupeKey)) {
    return false;
  }

  const sent = reachMetrikaGoal(goalName);
  if (sent) {
    setDedupeKey(dedupeKey);
  }

  return sent;
};
